import {
  addDoc,
  arrayRemove,
  deleteDoc,
  doc,
  FirestoreError,
  query,
  setDoc,
  updateDoc,
  where,
} from "firebase/firestore";
import { firestore } from "..";
import UserDataStore from "../../../store/UserDataStore";
import { CollectionName } from "../types/collections.types";
import { ContactGroup } from "../types/contact.types";
import { createCollection, subscribeCollection } from "./collectionService";

export const contactGroupCollection = createCollection<ContactGroup>(
  CollectionName.CONTACT_GROUPS
);

export const subscribeContactGroups = (
  onNewSnapshot: (contactGroups: ContactGroup[]) => void,
  onError: (err: FirestoreError) => void
) => {
  const user = UserDataStore.currentUser;
  if (!user?.userId) return;
  const contactGroupQuery = query(
    contactGroupCollection,
    where("userId", "==", user?.userId)
  );
  return subscribeCollection<ContactGroup>(
    contactGroupQuery,
    onNewSnapshot,
    onError
  );
};

export const addContactGroup = async (
  contactGroup: Omit<ContactGroup, "id">
) => {
  try {
    await addDoc(contactGroupCollection, contactGroup);
  } catch (e) {
    console.error(e);
  }
};

export const updateContactGroup = async (contactGroup: ContactGroup) => {
  const contactGroupRef = doc(
    firestore,
    CollectionName.CONTACT_GROUPS,
    contactGroup.id
  );
  await setDoc(contactGroupRef, contactGroup, { merge: true });
};

export const deleteContactGroup = async (contactGroupId: string) => {
  const contactGroupRef = doc(
    firestore,
    CollectionName.CONTACT_GROUPS,
    contactGroupId
  );
  await deleteDoc(contactGroupRef);
};

export const removeContactsFromGroup = async (
  groupId: string,
  contactIdsToRemove: string[]
) => {
  const groupRef = doc(firestore, CollectionName.CONTACT_GROUPS, groupId);
  return await updateDoc(groupRef, {
    contactIds: arrayRemove(...contactIdsToRemove),
  });
};

export default contactGroupCollection;
